// extracted by mini-css-extract-plugin
export var bgImage = "waveBackground-module--bgImage--8c29a";
export var leftPath = "waveBackground-module--leftPath--43b5d";
export var rightPath = "waveBackground-module--rightPath--624aa";
export var svgWrap = "waveBackground-module--svgWrap--ef5cc";
export var waveBg = "waveBackground-module--waveBg--04bef";
export var waveInner = "waveBackground-module--waveInner--bb7d4";